import { withTranslation } from 'react-i18next'
import SocialPopover from './SocialPopover'

export default withTranslation('user')<any>(SocialPopover)
